// Resolves the initial session before the router renders.
// 1. If the OAuth callback left an access token in the URL fragment, adopt it.
// 2. Otherwise attempt a silent refresh using the HttpOnly refresh cookie.
// 3. Load the current user (/api/users/me) into the store.

import { store } from './store.js'
import { api, setAccessToken, tryRefresh } from './api.js'

function readTokenFromHash() {
  if (!window.location.hash) return null
  const params = new URLSearchParams(window.location.hash.slice(1))
  const token = params.get('access_token')
  if (token) {
    // Strip the fragment so the token does not linger in the address bar.
    history.replaceState(null, '', window.location.pathname + window.location.search)
  }
  return token
}

export async function bootstrapAuth() {
  try {
    const hashToken = readTokenFromHash()
    if (hashToken) {
      setAccessToken(hashToken)
    } else {
      await tryRefresh()
    }

    const user = await api.get('/users/me').catch(() => null)
    if (user) {
      store.set({ user })
      await chooseLanding(user)
    }
  } finally {
    store.set({ authReady: true })
  }
}

// On a fresh load at the app root, an agent lands on the Triage queue when it has
// anything waiting, otherwise on Tickets. Only fires for a bare `/` — a direct link
// to any other route is left alone.
async function chooseLanding(user) {
  if (window.location.pathname !== '/') return
  if (user.role !== 'agent') return
  try {
    const { total } = await api.get('/tickets?view=triage&pageSize=1')
    history.replaceState(null, '', total > 0 ? '/triage' : '/tickets')
  } catch {
    history.replaceState(null, '', '/tickets')
  }
}
